export default "__VITE_ASSET__kxgSRCTW__"